import { IOErrorLOFactory } from './../../externalLogging/factories/IOErrorLOFactory';
import { SecurityErrorLOFactory } from './../../externalLogging/factories/SecurityErrorLOFactory';
import { ExternalLog } from './../../externalLogging/ExternalLog';
import { ILoadingObject } from "./ILoadingObject";
/**
 * Created with IntelliJ IDEA.
 * User: dkoehler
 * Date: 06.06.12
 * Time: 09:42
 * To change this template use File | Settings | File Templates.
 */

import Event = createjs.Event;
import IOErrorEvent = createjs.IOErrorEvent;
import ProgressEvent = createjs.ProgressEvent;
import SecurityErrorEvent = createjs.SecurityErrorEvent;

import { Signal } from "signals.js";

export class LoadingQueueEndElement implements ILoadingObject {
    private elementName: string;
    /** @private signal that this object has finished loading. */
    private _loaderObjectFinished: Signal = new Signal();
    private finishCallback: Function;

    public get loaderObjectFinished(): Signal {
        return this._loaderObjectFinished;
    }

    constructor(_elementName: string, _callback: Function) {
        this.elementName = _elementName;
        this.finishCallback = _callback;
    }

    public get loaderName(): string {
        return this.elementName;
    }

    public get totalBytes(): number {
        return 0;
    }

    public get loadedBytes(): number {
        return 0;
    }

    public startLoadingObject(_subloaderErrorLogging: boolean): void {
        this._loaderObjectFinished.dispatch(this.elementName);
    }

    public onLoadProgress(event: ProgressEvent): void {
    }

    public handleLoaderSecurityError(event: SecurityErrorEvent): void {
        ExternalLog.logger.log(new SecurityErrorLOFactory(SecurityErrorLOFactory.GENERAL_LOADER_SECURITY_ERROR, event.text, event.target.url));
    }

    public handleLoaderIOError(event: IOErrorEvent): void {
        ExternalLog.logger.log(new IOErrorLOFactory(IOErrorLOFactory.GENERAL_LOADER_IO_ERROR, event.text, event.target.url));
    }

    public onComplete(event: Event): void {
        if (this.finishCallback != null) {
            this.finishCallback();
        }
    }

    public get loaderInstance(): Object {
        return null;
    }

    public dispose(): void {
        this._loaderObjectFinished.removeAll();
    }
}

